import { trapCatchKeyForInsect } from 'App/dashboards/_utils/pestValueTypeKeys'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { sortByKey } from 'utils/sortByKey'

export type TTrapInfo = {
  lngLat: string
  trapName: string
  blockName: string | null
}

// Sort purely by trap name (natural order so "Trap 3" precedes "Trap 11"), blocks intermixed.
// There's no block filter yet, so grouping by block just scatters the alphabetical trap list — a
// flat alphabetical order is easier to scan. (Per product, 2026-06-10.) sortByKey → alphabeticalSort
// is the app-wide numeric collator.
const compareTraps = sortByKey<TTrapInfo>('trapName')

export const getTrapsForProperty = ({
  properties,
  propertyId,
  insectId,
}: {
  properties: TFieldAssetStoreState['properties']
  propertyId: number | null
  insectId: number
}): TTrapInfo[] => {
  if (propertyId === null) return []

  const property = properties?.[propertyId]

  if (!property) return []

  const blocks = property.blocks ?? {}
  const points = Object.values(property.points ?? {})
  const trapValueTypeKey = trapCatchKeyForInsect(insectId)

  return points
    .filter(
      (p) =>
        p.configuration?.trapInsectIds?.includes(insectId) &&
        p.valuesTimeseries?.some((vt) => vt === trapValueTypeKey),
    )
    .map((p): TTrapInfo => {
      const blockId = p.blockIds?.[0]
      const block = blockId !== undefined && blockId !== null ? blocks[blockId] : null

      return {
        lngLat: p.lngLat,
        trapName: p.name,
        blockName: block?.name ?? null,
      }
    })
    .sort(compareTraps)
}
